<template>
  <div class='coursework-viewer__slide js-code-runnable'>
    <div class='js-ko-runnable'>
      <!-- ko if: errorState() -->
      <div class='row'>
        <div class='col-xs-12 col-sm-6 col-md-3 center txt-c mt2 mb2'>
          <i class='svg-icon svg-icon__clr-dark svg-icon-xxl mb1'></i>
          <div class='missing-content__title mt0'></div>
          <!-- ko if: fileToLarge() -->
          <div class='typo__body mt1'></div>
          <!-- /ko -->
          <!-- ko if: !fileToLarge() -->
          <div class='typo__body mt1'></div>
          <!-- /ko -->
        </div>
      </div>
      <!-- /ko -->
      <!-- ko if: !errorState() -->
      <iframe class='coursework-viewer__runnable-demo js-ko-runnable-demo'></iframe>
      <!-- /ko -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      //TODO
      this.$emit('ready', this.media.id)
    }
  }
</script>